export enum ListFormats {
  unordered = 'unordered',
  ordered = 'ordered',
}

export const menuOrderedConfiguration = [
  {
    value: ListFormats.ordered,
    matIcon: 'format_list_numbered',
    label: 'se-ui-text-editor_cmd_enumerated_list_tooltip'
  }
];

export const menuUnOrderedConfiguration = [
  {
    value: ListFormats.unordered,
    matIcon: 'format_list_bulleted',
    label: 'se-ui-text-editor_cmd_not_enumerated_list_tooltip'
  }];
